<template>
    <div class="max-w-7xl mx-auto my-2">

        <TodoCardShow
            v-if="isShowing"
            :todo="todo"
            @update="changeStateToUpdate"
        />

        <TodoCardUpdate
            v-if="isUpdating"
            :todo="todo"
            @end="changeStateToEnd"
            @cancel="changeStateToShow"
        />
      
        <TodoCardEnd
            v-if="isEnding"
            :todo="todo"
            @update="changeStateToUpdate"
        />

    </div>
</template>

<script>
    import TodoCardShow from '@/components/Entrega/TodoCardShowEntrega.vue';
    import TodoCardUpdate from '@/components/Entrega/TodoCardUpdateEntrega.vue';
    import TodoCardEnd from '@/components/Entrega/TodoCardEndEntrega.vue';
    import { mapState, mapMutations, mapActions } from 'vuex'

    export default {
        name: 'TodoCard',

        components: {
            TodoCardShow,
            TodoCardUpdate,
            TodoCardEnd,
        },

        props: {
            todo: {
                type: Object,
                default: () => ({}),
            },
        },

        data() {
            return {
                
            };
        },

        computed: {

            ...mapState({
            mensagem: state => state.counter.mensagementrega,
            qtdaddress: state => state.counter.login.address
            }),   

            isShowing() {
                return this.todo.state === 'show';
            },

            isUpdating() {
                return this.todo.state === 'update';
            },

            isEnding() {
                return this.todo.state === 'end';
            },

        },

        methods: {
            changeStateToShow() {                
                this.$store.dispatch('counter/setState', { type: 'ENTREGA', value: 'show' })
                this.$store.dispatch('counter/setisEdit', { type: 'ENTREGA', value: false });
                this.$store.dispatch('counter/setHideAddress', { type: 'ENTREGA', value: true });     
                //this.todo.state = 'show';
            },

            changeStateToUpdate() {
                this.$store.dispatch('counter/setState', { type: 'ENTREGA', value: 'update' })
                //this.todo.state = 'update';
            },

            changeStateToEnd() {
                this.$store.dispatch('counter/setState', { type: 'ENTREGA', value: 'end' })
                this.$store.dispatch('counter/setState', { type: 'PAGAMENTO', value: 'update' })
                this.$store.dispatch('counter/setArea', { type: 'ENTREGA', value: 2 });                
                //this.todo.state = 'end';
            },

        },
    };
</script>
